import { S3FileInfo } from "@certn/cascadia-react/deprecated/upload/types";
import { components } from "@certn/legacy-api/generated-schemas/people";

export function convertDocumentToS3FileInfo(
  document: components["schemas"]["SingleDocumentCheckFieldValue"]
): S3FileInfo {
  return {
    document: {
      document_id: document.id,
    } as S3FileInfo["document"],
    type: document.file_type,
    name: document.file_name,
    url: document.get_url,
    size: 0,
  };
}

export function download(url: string, fileName: string) {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
